export default {
  hero: {
    title: 'Contact Us',
    subtitle: 'We are always ready to listen and support you',
  },
  info: {
    title: 'Contact Information',
    description: 'Reach us through the channels below or fill out the form. Our specialist team will respond within 24 hours.',
    address: {
      label: 'Address',
      value: 'Krisjana Barona Iela 96/98, Riga, Latvia',
      line2: 'We do not have an office in Vietnam',
    },
    phone: {
      label: 'Phone',
      value: '+371 2572 6969',
      display: 'Latvia: +371 2572 6969 (Call / Whatsapp / Viber)',
    },
    email: {
      label: 'Email',
      value: 'contact@thedaeg.com',
    },
    hours: {
      label: 'Working Hours',
      value: 'Monday - Friday: 9:00 - 18:00',
      saturday: 'Saturday: 9:00 - 12:00',
    },
  },
  social: {
    title: 'Follow Us',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
  },
  form: {
    title: 'Send Us a Message',
    description: 'Fill out the form below and we will respond within 24 hours.',
    labels: {
      fullName: 'Full Name',
      phone: 'Phone Number',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
    },
    placeholders: {
      fullName: 'Enter your full name',
      phone: 'Phone number',
      email: 'Email',
      subject: 'What do you need help with?',
      message: 'Describe your question in detail... (max 500 characters)',
    },
    required: 'Required',
    submit: 'Send Message',
    submitting: 'Sending...',
    success: 'Message sent successfully! We will contact you soon.',
    error: 'An error occurred. Please try again later.',
    charCount: 'characters',
  },
  breadcrumb: {
    home: 'Home',
    contact: 'Contact',
  },
} as const;
